export default __webpack_public_path__ + "static/media/ve_0.64485f75.mp3";